module.exports = __webpack_public_path__ + "img/glas_4.2c805ad3.png";